module.exports = __webpack_public_path__ + "static/media/background_slider.39b090be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/background_slider.jpg
// module id = 782
// module chunks = 0